import React, { FC } from 'react';
import { Text } from 'react-native';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';

interface ProductionOrderDetailsNCFilePerformanceUtilizationProps {}

const ProductionOrderDetailsNCFilePerformanceUtilization: FC<ProductionOrderDetailsNCFilePerformanceUtilizationProps> = () => {
  return (
    <DetailsPageWrapper title="Job">
      <Text>JobDetailsNCFilePerformanceUtilization</Text>
    </DetailsPageWrapper>
  );
};

export { ProductionOrderDetailsNCFilePerformanceUtilization };
